// frappe.Chat
// Author - Nihal Mittal <nihal@erpnext.com>

import {
  ChatList,
  ChatSpace,
  ChatWelcome,
  get_settings,
  scroll_to_bottom,
} from './components';
frappe.provide('frappe.Chat');
frappe.provide('frappe.Chat.settings');

/** Spawns a chat widget on any web page */
frappe.Chat = class {
  constructor() {
    this.is_rtl = this.get_is_rtl();
    frappe.Chat.instance = this;
    this.open_title = __('Show Chats');
    this.closed_title = __('Close Chat');
    this.preview_queue = [];
    this.preview_active = false;
    this.preview_timeout = null;
    this.remove_navbar_icon();
    this.setup_app();
  }

  /** Create all the required elements for chat widget */
  create_app() {
    this.$app_element = $(document.createElement('div'));
    this.$app_element.addClass('chat-app');
    // if (this.is_rtl) {
    //   this.$app_element.addClass('chat-rtl');
    // }
    this.$chat_container = $(document.createElement('div'));
    this.$chat_container.addClass('chat-container');
    $('body').append(this.$app_element);
    this.is_open = false;

    this.$chat_element = $(document.createElement('div'))
      .addClass('chat-element')
      .hide();

    this.$chat_element.append(`
			<span class="chat-cross-button">
				${frappe.utils.icon('close', 'lg')}
			</span>
		`);
    this.$chat_element.append(this.$chat_container);
    this.$chat_element.appendTo(this.$app_element);

    this.setup_preview_components();
    this.render_trigger_button();
    this.setup_events();
  }

  /** Load dependencies and fetch the settings */
  async setup_app() {
    try {
      const token = localStorage.getItem('guest_token') || '';
      const res = await get_settings(token);
      this.is_admin = res.is_admin;
      this.is_desk = 'desk' in frappe;
      this.open_title = this.is_admin ? __('Show Chats') : __('Chat With Us');

      if (
        res.enable_chat === false ||
        (!this.is_desk && this.is_admin) ||
        this.is_desk === false
      ) {
        return;
      }

      this.create_app();
      await frappe.socketio.init(res.socketio_port);

      frappe.Chat.settings = {};
      frappe.Chat.settings.user = res.user_settings;
      frappe.Chat.settings.unread_count = 0;

      if (res.is_admin) {
        // If the user is admin, render everthing
        this.chat_list = new ChatList({
          $wrapper: this.$chat_container,
          user: res.user,
          user_email: res.user_email,
          is_admin: res.is_admin,
        });
        this.chat_list.render();
      } else if (res.is_verified) {
        // If the token and ip address matches, directly render the chat space
        this.chat_space = new ChatSpace({
          $wrapper: this.$chat_container,
          profile: {
            room_name: res.guest_title,
            room: res.room,
            is_admin: res.is_admin,
            user: res.user,
            user_email: res.user_email,
          },
        });
      } else {
        //Render the welcome screen if the user is not verified
        this.chat_welcome = new ChatWelcome({
          $wrapper: this.$chat_container,
          profile: {
            name: res.guest_title,
            is_admin: res.is_admin,
            chat_status: res.chat_status,
          },
        });
        this.chat_welcome.render();
      }
    } catch (error) {
      console.error(error);
    }
  }

  render_trigger_button() {
    const icon_svg = `
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 5.5h14a1.5 1.5 0 0 1 1.5 1.5v7.5A1.5 1.5 0 0 1 19 16H14.2L12 18.2 9.8 16H5a1.5 1.5 0 0 1-1.5-1.5V7a1.5 1.5 0 0 1 1.5-1.5Z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 9.25h8M8 12h5"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;
    if (this.$trigger_button) {
      this.$trigger_button.remove();
    }
    this.$trigger_button = $(document.createElement('button'))
      .addClass('chat-floating-button')
      .attr({
        type: 'button',
        title: this.open_title,
      })
      .html(`
        <span class="chat-floating-button__pulse"></span>
        <span class="chat-floating-button__icon">
          ${icon_svg}
        </span>
        <span class="badge" id="chat-notification-count"></span>
      `);

    this.$trigger_button.on('click', () => {
      this.toggle_chat();
    });
    this.$app_element.append(this.$trigger_button);
    this.update_trigger_state();
  }

  update_trigger_state() {
    if (!this.$trigger_button) {
      return;
    }
    this.$trigger_button.attr(
      'title',
      this.is_open ? this.closed_title : this.open_title
    );
    this.$trigger_button.toggleClass('is-open', this.is_open);
  }

  /** Shows the chat widget */
  show_chat_widget() {
    this.is_open = true;
    this.$chat_element.fadeIn(250);
    this.clear_message_previews();
    if (typeof this.chat_space !== 'undefined') {
      scroll_to_bottom(this.chat_space.$chat_space_container);
    }
    this.update_trigger_state();
  }

  /** Hides the chat widget */
  hide_chat_widget() {
    this.is_open = false;
    this.$chat_element.fadeOut(300);
    this.update_trigger_state();
  }

  toggle_chat() {
    if (this.is_open) {
      this.hide_chat_widget();
    } else {
      this.show_chat_widget();
    }
  }

  setup_preview_components() {
    this.$preview_stack = $(document.createElement('div'));
    this.$preview_stack.addClass('chat-preview-stack').hide();
    this.$app_element.append(this.$preview_stack);
  }

  enqueue_message_preview(payload) {
    if (this.is_open || !this.$preview_stack) {
      return;
    }
    const room_name = payload.room_name || __('New message');
    const message = this.truncate_preview_text(payload.message);
    this.preview_queue.push({ room_name, message });
    if (!this.preview_active) {
      this.show_next_preview();
    }
  }

  truncate_preview_text(message) {
    if (!message) {
      return __('You have a new message');
    }
    const sanitized = $('<div>').text(message).text().trim();
    if (!sanitized) {
      return __('You have a new message');
    }
    return sanitized.length > 64 ? `${sanitized.substring(0, 61)}...` : sanitized;
  }

  show_next_preview() {
    if (this.preview_queue.length === 0 || this.is_open) {
      this.preview_active = false;
      this.hide_preview_stack();
      return;
    }
    this.preview_active = true;
    const preview = this.preview_queue.shift();
    const $card = $('<div class="chat-preview-card"></div>');
    $('<div class="chat-preview-card__room"></div>')
      .text(preview.room_name)
      .appendTo($card);
    $('<div class="chat-preview-card__message"></div>')
      .text(preview.message)
      .appendTo($card);

    this.$preview_stack.empty().append($card).show().addClass('is-visible');
    const raf =
      (typeof window !== 'undefined' && window.requestAnimationFrame) ||
      function (cb) {
        return setTimeout(cb, 16);
      };
    raf(() => {
      $card.addClass('is-entering');
    });

    clearTimeout(this.preview_timeout);
    this.preview_timeout = setTimeout(() => {
      $card.removeClass('is-entering').addClass('is-leaving');
      setTimeout(() => {
        $card.remove();
        this.preview_active = false;
        this.show_next_preview();
      }, 220);
    }, 4200);
  }

  hide_preview_stack() {
    clearTimeout(this.preview_timeout);
    if (this.$preview_stack) {
      this.$preview_stack.removeClass('is-visible').empty().hide();
    }
  }

  clear_message_previews() {
    this.preview_queue = [];
    this.preview_active = false;
    this.hide_preview_stack();
  }

  remove_navbar_icon() {
    const removeIcon = () => {
      const $icon = $('.chat-navbar-icon');
      if ($icon.length) {
        $icon.remove();
        return true;
      }
      return false;
    };

    removeIcon();

    $(document).on('toolbar_setup page-change', () => {
      removeIcon();
    });

    let attempts = 0;
    const interval = setInterval(() => {
      attempts += 1;
      if (removeIcon() || attempts >= 10) {
        clearInterval(interval);
      }
    }, 300);
  }

  should_close(e) {
    const chat_app = $('.chat-app');
    const navbar = $('.navbar');
    const modal = $('.modal');
    return (
      !chat_app.is(e.target) &&
      chat_app.has(e.target).length === 0 &&
      !navbar.is(e.target) &&
      navbar.has(e.target).length === 0 &&
      !modal.is(e.target) &&
      modal.has(e.target).length === 0
    );
  }

  setup_events() {
    const me = this;
    $(document).mouseup(function (e) {
      if (me.should_close(e) && me.is_open === true) {
        me.hide_chat_widget();
      }
    });
    this.$chat_element.on('click', '.chat-cross-button', () => {
      this.hide_chat_widget();
    });
  }

  get_is_rtl() {
    if (
      typeof frappe !== 'undefined' &&
      frappe.utils &&
      typeof frappe.utils.is_rtl === 'function'
    ) {
      return frappe.utils.is_rtl();
    }
    if (
      typeof frappe !== 'undefined' &&
      frappe.boot &&
      frappe.boot.lang &&
      typeof frappe.boot.lang === 'string'
    ) {
      return frappe.boot.lang.toLowerCase().indexOf('ar') === 0;
    }
    return false;
  }
};

$(function () {
  new frappe.Chat();
});
